import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';

var DialogCard = function (_a) {
    var sx = _a.sx, props = __rest(_a, ["sx"]);
    var mergeStyles = useTheme().mergeStyles;
    var baseStyle = mergeStyles([
        {
            display: "grid",
            p: 0,
            maxHeight: "inherit",
            boxShadow: 6,
            backgroundColor: "white",
            borderRadius: 3,
        },
        sx,
    ]);
    return jsx(Box, __assign({ sx: baseStyle }, props));
};

export { DialogCard };
//# sourceMappingURL=DialogCard.js.map
